// Stelle der Werkskennung in einem vom Server gelieferten Zielnamen.
// Der Name selbst wird hier NIE gebaut oder aus dem Quellnamen abgeleitet: ermittelt wird nur,
// welcher Abschnitt des Servernamens hervorgehoben wird. Ohne eindeutige Stelle: null.

const numerisch = value => (/^\d+$/.test(value) ? value.replace(/^0+(?=\d)/, "") : null);

// Fundstellen der Kennung. Eine numerische Kennung gilt wie im Server (samePlant) auch in
// gleichwertiger Schreibweise (040 = 0040), aber nur als vollständige Ziffernfolge.
function fundstellen(target, kennung) {
  const hits = [];
  const wert = numerisch(kennung);
  if (wert !== null) {
    for (const m of target.matchAll(/\d+/g)) if (numerisch(m[0]) === wert) hits.push({ start: m.index, end: m.index + m[0].length });
    return hits;
  }
  for (let i = target.indexOf(kennung); i >= 0; i = target.indexOf(kennung, i + 1)) hits.push({ start: i, end: i + kennung.length });
  return hits;
}

// Abschnitt des Zielnamens, der sich gegenüber dem Quellnamen unterscheidet (gemeinsamer
// Anfang und gemeinsames Ende abgezogen). null ohne Quellnamen.
function geaenderterAbschnitt(source, target) {
  if (!source || source === target) return null;
  let p = 0;
  while (p < source.length && p < target.length && source[p] === target[p]) p++;
  let s = 0;
  while (s < source.length - p && s < target.length - p && source[source.length - 1 - s] === target[target.length - 1 - s]) s++;
  return { start: p, end: target.length - s };
}

export function kennungStelle(sourceName, targetName, kennung) {
  const target = typeof targetName === "string" ? targetName : "";
  const code = String(kennung || "");
  if (!target || !code) return null;
  // Gleicher Name: der Server hat keine Kennung eingefügt, eine gleichwertige Fachnummer
  // im Namen ist dann keine Werkskennung.
  if (String(sourceName || "") === target) return null;
  let hits = fundstellen(target, code);
  const abschnitt = geaenderterAbschnitt(String(sourceName || ""), target);
  if (abschnitt) {
    // Reine Einfügung: der Abschnitt kann leer sein, die Kennung grenzt dann an seine Position.
    hits = hits.filter(h => abschnitt.start === abschnitt.end
      ? h.start <= abschnitt.start && h.end >= abschnitt.end
      : h.start < abschnitt.end && h.end > abschnitt.start);
  }
  return hits.length === 1 ? hits[0] : null;
}
